import { render, staticRenderFns } from "./mr_widget_icon.vue?vue&type=template&id=097ed84f"
import script from "./mr_widget_icon.vue?vue&type=script&lang=js"
export * from "./mr_widget_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports